<template>
    <div>
        <rkm-data-table
            :fields="fields"
            :repository="repositories.formularioRaas"
            ref="DataTable"
            sort-by="data"
        >
            <template v-slot:cell(pacienteNome)="{ index, item }">
                <template v-if="item.pacienteNome">
                    <rkm-button
                        :id="uniqueId(`paciente-icon-${index}`)"
                        class="mr-2"
                        small
                    >
                        <rkm-icon icon="user" />
                    </rkm-button>

                    <rkm-popover
                        :target="uniqueId(`paciente-icon-${index}`)"
                        placement="top"
                        title="Dados cadastrais"
                        triggers="hover"
                    >
                        <div>
                            <span>
                                <strong>Data de nascimento:</strong> {{ item.pacienteDataNascimento }}
                            </span>
                        </div>

                        <div>
                            <span>
                                <strong>Nome da mãe:</strong> {{ item.pacienteNomeMae }}
                            </span>
                        </div>

                        <div>
                            <span>
                                <strong>CPF:</strong> {{ item.pacienteCpf }}
                            </span>
                        </div>

                        <div>
                            <span>
                                <strong>CNS:</strong> {{ item.pacienteCns }}
                            </span>
                        </div>
                    </rkm-popover>

                    <template>
                        {{ item.pacienteNome }}

                        <template v-if="item.pacientePreferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                            <strong>
                                ({{ item.pacienteNomeSocial }})
                            </strong>
                        </template>
                    </template>
                </template>
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="$refs.Modal.open(item.id)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>
            </template>
        </rkm-data-table>

        <Modal ref="Modal" />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

// Mixins.
import { repository } from '@/mixins'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    components: { Modal },
    created() {

        this.repositories = {
            formularioRaas: this.getConectaSusRepository('ambulatorio.formularioRaas')
        }
    },
    data: () => ({
        fields: [
            { key: 'data', name: 'data', label: 'Data', class: 'col-min', searchable: true, sortable: true },
            { key: 'pacienteNome', name: 'pacienteCidadao.nome', label: 'Paciente', searchable: true, sortable: true },
            { key: 'pacienteProntuario', name: 'paciente.prontuario', label: 'Prontuário', searchable: true, sortable: true, class: 'col-min' },
            { key: 'usuarioNome', name: 'usuarioCidadao.nome', label: 'Profissional', searchable: true, sortable: true },
            { key: 'especialidadeNome', name: 'especialidade.nome', label: 'Especialidade', searchable: true, sortable: true },
            { key: 'horarioChegada', name: 'horarioChegada', label: 'Horário de chegada', sortable: true, class: 'col-min' },
            { key: 'horarioAgendado', name: 'agendamento.horario', label: 'Horário agendado', sortable: true, class: 'col-min' },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
        enums: { preferenciaNome },
    }),
    mixins: [repository],
}
</script>